import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { Package, ArrowRight } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import SEO from "@/components/SEO";

export default function Orders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        (async () => {
            const r = await api.get("/orders");
            setOrders(r.data.orders);
            setLoading(false);
        })();
    }, []);

    return (
        <div className="max-w-[1200px] mx-auto px-4 md:px-8 lg:px-12 py-10">
            <SEO title="My Orders" description="Your order history on LoyltyKart." path="/orders" noindex />
            <h1 className="font-serif text-4xl md:text-5xl mb-6">My Orders</h1>
            {loading ? (
                <p className="text-[#6C6F7A]">Loading…</p>
            ) : orders.length === 0 ? (
                <div className="py-20 text-center bg-white border border-[#E5E0D5] rounded-2xl">
                    <Package className="w-12 h-12 mx-auto text-[#E5E0D5] mb-3" />
                    <p className="font-serif text-2xl">No orders yet</p>
                    <p className="text-sm text-[#6C6F7A] mt-1">Start shopping to build memories.</p>
                    <Link to="/catalog" className="rk-btn-primary inline-block mt-5 !text-sm">Browse brands</Link>
                </div>
            ) : (
                <div className="space-y-3">
                    {orders.map((o) => (
                        <Link
                            to={`/orders/${o.id}/success`}
                            key={o.id}
                            data-testid={`order-${o.id}`}
                            className="block bg-white border border-[#E5E0D5] rounded-2xl p-5 hover:border-[#0B1437] transition"
                        >
                            <div className="flex items-center justify-between flex-wrap gap-3">
                                <div>
                                    <div className="text-xs text-[#6C6F7A]">Order #{o.short_id}</div>
                                    <div className="font-serif text-xl">{o.items.length} item(s) · {formatINR(o.amount_inr)}</div>
                                    <div className="text-xs text-[#6C6F7A] mt-1">
                                        {new Date(o.created_at).toLocaleString("en-IN")}
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className={`text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider ${
                                        o.status === "paid" ? "bg-[#1D5C42]/10 text-[#1D5C42]" :
                                        o.status === "pending_payment" ? "bg-[#B88A1A]/10 text-[#B88A1A]" :
                                        "bg-[#0B1437]/10 text-[#0B1437]"
                                    }`}>
                                        {o.status.replace("_", " ")}
                                    </span>
                                    <ArrowRight className="w-5 h-5 text-[#6C6F7A]" />
                                </div>
                            </div>
                            <div className="mt-3 flex items-center gap-2">
                                {o.items.slice(0, 6).map((it, i) => (
                                    <div key={i} className="w-10 h-10 rk-logo-box flex items-center justify-center">
                                        <BrandLogo brand={it} size="sm" />
                                    </div>
                                ))}
                                {o.items.length > 6 && (
                                    <span className="text-xs text-[#6C6F7A]">+{o.items.length - 6} more</span>
                                )}
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
